import Vue from "vue";
import Vuex from "vuex";
import userModule from "./modules/user/store";
import structureModule from "./modules/structure/store";
import dailyReportModule from "./modules/dailyReport/store";
import planingModule from "./modules/planing/store";
import taskModule from "./modules/task/store";
import absenceRequestModule from "./modules/absenceRequest/store";
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user: userModule,
    structure: structureModule,
    dailyReport: dailyReportModule,
    planing: planingModule,
    task: taskModule,
    absenceRequest: absenceRequestModule
  }
});

export default store;
